export const GENERIC_FIELD_TYPES = [
  { type: "text", label: "Text scurt" },
  { type: "textarea", label: "Text lung" },
  { type: "number", label: "Număr" },
  { type: "date", label: "Dată" },
  { type: "checkbox", label: "Bifă" },
  { type: "select", label: "Listă" },
  { type: "multiselect", label: "Multi-select" },
  { type: "smart_goals", label: "Obiective SMART" },
  { type: "scale_score", label: "Scală evaluare" },
  { type: "repeatable_group", label: "Grup repetabil" },
  { type: "icd_diagnosis", label: "Diagnostic ICD" },
  { type: "body_chart", label: "Hartă corporală" },
  { type: "meal_plan_week", label: "Plan meniu săptămână" },
]

export function defaultFieldValue(field) {
  const t = field?.type
  if (t === "checkbox") return false
  if (t === "smart_goals") return { short: [], medium: [], long: [] }
  if (t === "multiselect") return []
  if (t === "repeatable_group") return []
  if (t === "meal_plan_week") return { days: [], targets: { kcal: null, protein_g: null } }
  if (t === "body_chart") return { view: "front", regions: [], pressure_notes: "", techniques: [] }
  if (t === "scale_score") return { scale: field.scale || "", score: null, notes: "" }
  if (t === "icd_diagnosis") return { code: "", label: "", system: "ICD-11" }
  return ""
}

export function newFieldId() {
  return `field_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`
}

export function newSectionId() {
  return `sec_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`
}

export const emptyDefinition = (modality = "psych") => ({
  version: 1,
  modality,
  title: "Șablon nou",
  legal_basis: [],
  sections: [{ id: newSectionId(), label: "Secțiune 1", fields: [] }],
})
